module.exports = __webpack_public_path__ + "9af99a099c25e2943fed8641ecd304f4.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/ppfPreview/ir_55.jpg
// module id = 1716
// module chunks = 5